import { Stack, styled } from "@mui/material";

export const CurrencyExchangeRateWrapper = styled(Stack)(({ theme }) => {
    return {
        gap: "var(--flex-gap)",
        overflow: "hidden",
        "& .currency-exchange-rate-table-box": {
            "& .MuiTableContainer-root": {
                borderRadius: "16px",
                "& .MuiTableHead-root": {
                    "& .MuiTableCell-root": {
                        whiteSpace: "nowrap",
                    },
                    "& .MuiTableCell-root:last-child": {
                        width: "25%",
                    }
                }
            },
        },
    }
})